import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e53e291"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-result", _ctx.resultClass]),
    style: _normalizeStyle(_ctx.resultStyle)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["thumb", _ctx.thumbContainerClass])
    }, [
      _createElementVNode("img", {
        src: _ctx.result.image,
        draggable: "false"
      }, null, 8, _hoisted_1)
    ], 2),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.result.title), 1),
    _createElementVNode("div", {
      class: "description",
      innerHTML: _ctx.result.description
    }, null, 8, _hoisted_3),
    _createElementVNode("button", {
      disabled: _ctx.isButtonDisabled,
      class: _normalizeClass(_ctx.buttonClass),
      style: _normalizeStyle(_ctx.buttonStyle),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
    }, _toDisplayString(_ctx.buttonText), 15, _hoisted_4)
  ], 6))
}